import React, { useEffect } from "react";
import "./home.scss";
import HomeCarousel from "./homeCarousel/HomeCarousel";
import HomeNewProducts from "./homeNewProducts/HomeNewProducts";
import filterStore from "../../store/filterStore";
import HeroSection from "./heroSection/HeroSection";
import HorizontalScrollProduct from "./horizontalScrollProduct/HorizontalScrollProduct";
import ProductBox from "./productBox/ProductBox";
import MostPopular from "./mostPopular/MostPopular";
import LogoZoomer from "./logoZoomer/LogoZoomer";
import SliderProduct from "./sliderProduct/SliderProduct";
import ImageCarousel from "./homeCarousel/ImageCarousel";
import ValentinesCountdown from "./valentinesCountdown/ValentinesCountdown";

const Home = () => {
  const FilterStore = filterStore();

  useEffect(() => {
    FilterStore.resetFilters();
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="home">
      <ImageCarousel />
      {/* <ValentinesCountdown /> */}
      {/* <HomeCarousel /> */}
      {/* <LogoZoomer /> */}
      {/* <HeroSection /> */}
      {/* <HorizontalScrollProduct /> */}
      <SliderProduct />
      {/* <HomeNewProducts /> */}
      <ProductBox />
      <MostPopular />
    </div>
  );
};

export default Home;
